import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
interface NavDropdownProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const NavDropdown = (props: NavDropdownProps) => {
  const { title, icon, children, className } = props;
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState<number | undefined>(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`relative text-left w-full ${className}`}>
      <button
        onClick={toggleDropdown}
        className="flex items-center text-sm justify-between w-full px-2 py-3 text-gray-400 hover:text-white rounded-md focus:outline-none"
      >
        <div className="flex items-center">
          {icon}
          <span className="ml-2">{title}</span>
        </div>
        {isOpen ? (
          <FaChevronUp className="ml-2 transition-transform duration-300" />
        ) : (
          <FaChevronDown className="ml-2 transition-transform duration-300" />
        )}
      </button>
      <div
        ref={contentRef}
        style={{
          maxHeight: isOpen ? contentHeight : 0,
        }}
        className="overflow-hidden transition-max-height duration-300 ease-in-out"
      >
        <div className="w-full text-sm rounded-md shadow-lg">{children}</div>
      </div>
    </div>
  );
};

export default NavDropdown;
